import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { setWarning } from "../../reducers/appSlice";
import BuscadorPersonaFisica from "../../commons/BuscadorPersonaFisica";
import BuscadorPersonaJuridica from "../../commons/BuscadorPersonaJuridica";
import BuscadorOrganismo from "../../commons/BuscadorOrganismo";
import ModalEmail from "../../commons/ModalEmail";
import ModalDomicilio from "../../commons/ModalDomicilio";

const TableCellHead = styled(TableCell)(({ theme }) => ({
  color: "#3c4b64",
}));

const Iniciadores = (props) => {
  const dispatch = useDispatch();
  const [iniciadores, setIniciadores] = useState(props.iniciadores);

  const agregarIniciador = (iniciador) => {
    let nuevo = {
      personaId: iniciador.personaId ? iniciador.personaId : null,
      organismoId: iniciador.organismoId ? iniciador.organismoId : null,
      localidadId: iniciador.localidadId ? iniciador.localidadId : null,
      domicilioId: iniciador.domicilioId ? iniciador.domicilioId : null,
      domicilio: iniciador.domicilio ? iniciador.domicilio : null,
      domicilioCompleto: iniciador.domicilio ? iniciador.domicilio : null,
      email: iniciador.email ? iniciador.email : null,
      nombre: iniciador.nombre ? iniciador.nombre : null,
      tipo: iniciador.tipo,
    };

    for (let index = 0; index < iniciadores.length; index++) {
      const elemento = iniciadores[index];
      if (
        (elemento.personaId !== null &&
          elemento.personaId === nuevo.personaId) ||
        (elemento.organismoId !== null &&
          elemento.organismoId === nuevo.organismoId)
      ) {
        dispatch(setWarning("Iniciador ya agregado."));
        return;
      }
    }

    setIniciadores((prevState) => [...prevState, nuevo]);
  };

  const quitarIniciador = (index) => {
    let nuevo = [...iniciadores];
    nuevo.splice(index, 1);
    setIniciadores(nuevo);
  };

  const handleFisicas = (fisica) =>
    agregarIniciador({
      personaId: fisica.id,
      domicilioId: fisica.domicilioId,
      domicilio: fisica.domicilio,
      email: fisica.email,
      nombre: fisica.apellido + ", " + fisica.nombres,
      tipo: "fisica",
    });

  const handleJuridicas = (juridica) =>
    agregarIniciador({
      personaId: juridica.id,
      domicilioId: juridica.domicilioId,
      domicilio: juridica.domicilio,
      email: juridica.email,
      nombre: juridica.razonSocial,
      tipo: "juridica",
    });

  const handleOrganismos = (organismo) =>
    agregarIniciador({
      organismoId: organismo.id,
      nombre: organismo.descOrgCompleta,
      email: organismo.email,
    });

  const handleEmail = (resultado) => {
    let involucrados = [...iniciadores];

    for (let index = 0; index < involucrados.length; index++) {
      if (
        (involucrados[index].personaId === resultado.personaId && involucrados[index].personaId !== null) ||
        (involucrados[index].organismoId === resultado.organismoId && involucrados[index].organismoId !== null)
      ) {
        involucrados[index].email = resultado.email;
      }
    }

    setIniciadores(involucrados);
  };

  const handleDomicilio = (resultado) => {
    let involucrados = [...iniciadores];

    for (let index = 0; index < involucrados.length; index++)
      if (involucrados[index].personaId === resultado.personaId) {
        involucrados[index].localidadId = resultado.localidadId;
        involucrados[index].domicilioId = null;
        involucrados[index].domicilio = resultado.domicilio;
        involucrados[index].domicilioCompleto = resultado.domicilioCompleto;
      }

    setIniciadores(involucrados);
  };

  useEffect(() => {
    setIniciadores(props.iniciadores);
  }, [props.iniciadores]);

  useEffect(() => {
    props.handleIniciadores(iniciadores);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iniciadores]);

  return (
    <>
      <Grid container mb={2}>
        <Grid
          item
          lg={4}
          md={4}
          sm={4}
          xs={12}
          sx={{
            textAlign: {
              xs: "center",
              md: "left",
            },
          }}
        >
          <BuscadorPersonaFisica
            resultado={handleFisicas}
            activo={"S"}
            mostrar="boton"
            sx={{
              width: {
                xs: "100%",
              },
            }}
          />
        </Grid>
        <Grid
          item
          lg={4}
          md={4}
          sm={4}
          xs={12}
          sx={{
            textAlign: {
              xs: "center",
              md: "center",
            },
          }}
        >
          <BuscadorPersonaJuridica
            resultado={handleJuridicas}
            activo={"S"}
            mostrar="boton"
            sx={{
              width: {
                sm: "100%",
              },
            }}
          />
        </Grid>
        <Grid
          item
          lg={4}
          md={4}
          sm={4}
          xs={12}
          sx={{
            textAlign: {
              xs: "center",
              md: "right",
            },
          }}
        >
          <BuscadorOrganismo resultado={handleOrganismos} mostrar="boton" accion="consulta" />
        </Grid>
      </Grid>

      <TableContainer>
        <Table
          aria-label="tabla iniciadores"
          sx={{ border: "1px solid #dee2e6" }}
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCellHead align="left" padding="normal">
                <b>Iniciadores</b>
              </TableCellHead>
              {props.completo === "S" ? (
                <>
                  <TableCellHead align="left" padding="normal">
                    <b>Domicilio</b>
                  </TableCellHead>
                  <TableCellHead align="left" padding="normal">
                    <b>E-mail</b>
                  </TableCellHead>
                </>
              ) : null}
              <TableCellHead align="center" padding="normal" width={100}>
                <b>Acciones</b>
              </TableCellHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {iniciadores.map((iniciador, index) => {
              return (
                <TableRow
                  key={index}
                  sx={
                    index % 2 === 0
                      ? { backgroundColor: "#f2f2f2" }
                      : { backgroundColor: "#fff" }
                  }
                >
                  <TableCell align="left" width="400">
                    {iniciador.nombre}
                  </TableCell>
                  {props.completo === "S" ? (
                    <>
                      <TableCell align="left" width="300">
                        {iniciador.domicilioCompleto}
                      </TableCell>
                      <TableCell align="left" width="200">
                        {iniciador.email}
                      </TableCell>
                    </>
                  ) : null}

                  <TableCell align="center" width={100}>
                    {(iniciador.personaId !== null || iniciador.organismoId !== null) && (props.completo === "S") ? (
                      <ModalEmail
                        iniciador={iniciador}
                        resultado={handleEmail}
                        tienePermisoAgregarAdjunto={"S"}
                      />
                    ) : null}
                    {(iniciador.personaId !== null) && (props.completo === "S") ? (
                      <ModalDomicilio
                        persona={iniciador}
                        resultado={handleDomicilio}
                      />
                    ) : null}
                    <IconButton
                      title="Quitar"
                      size="small"
                      onClick={() => quitarIniciador(index)}
                    >
                      <DeleteOutlineOutlinedIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
            {iniciadores.length === 0 ? (
              <TableRow>
                <TableCell colSpan="4" align="center">
                  <Typography variant="aclaracion">Sin iniciadores</Typography>
                </TableCell>
              </TableRow>
            ) : (
                ""
              )}
          </TableBody>
        </Table>
      </TableContainer>
      <br></br>
      <br></br>
    </>
  );
};

Iniciadores.propTypes = {
  handleIniciadores: PropTypes.func.isRequired,
  iniciadores: PropTypes.array.isRequired,
};

Iniciadores.defaultProps = {
  iniciadores: [],
};

export default Iniciadores;